import { useMutation } from 'react-query';
import { updateDashboard } from '@src/api/dashboards';

function useUpdateDashboard() {
  const updateMutation = useMutation(updateDashboard);

  return { updateMutation };
}

export default useUpdateDashboard;